<template>
  <li
    v-bind:class="{ active: sidebarActiveButton === 'box' }"
    @click="goToBox()"
    :title="$t('general.labels.themes')">
    <i class="kp-panel-pop-up"></i>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    sidebarActiveButton: 'sidebarActiveButton',
    boxThemeSlug: 'boxThemeSlug',
    boxFormat: 'boxFormat',
  }),
  methods: {
    goToBox() {
      let destiny = 'themes';

      if (!this.boxFormat) {
        destiny = 'types';
      }

      this.sidebarChangePanel(destiny);
      this.sidebarChangeActiveButton('box');
      this.canvasChangeView('preview');
    },
    ...mapActions([
      'sidebarChangePanel',
      'sidebarChangeActiveButton',
      'canvasChangeView',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** Model.vue?72ce76ac
 **/